import { createMuiTheme } from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#4676e0',
    },
    grey: {
      40: '#f3f5f9',
    },
    secondary: {
      main: '#4676e0',
    },
  },
  typography: {
    h1: {
      fontSize: '1.5rem',
      fontWeight: '700',
    },
    h2: {
      fontSize: '1rem',
      fontWeight: 'bold',
    },
  },
}, ptBR);

export default theme;
